const button = document.querySelectorAll(".price-calculation-model__btn");
const model = document.querySelector(".price-calculation-model");
const closeModel = document.querySelector(".price-calculation-model__btn-close");

if (closeModel && model) {
  button.forEach((btn) => {
    btn.addEventListener("click", () => {
      model.showModal();
      document.body.classList.add("modal-open");
    });

    closeModel.addEventListener("click", () => {
      model.close();
      document.dispatchEvent(new CustomEvent("resetCalculation", {}));
    });

    model.addEventListener("mousedown", (event) => {
      if (event.target === model) {
        model.close();
        document.dispatchEvent(new CustomEvent("resetCalculation", {}));
      }
    });

    model.addEventListener("close", () => {
      document.body.classList.remove("modal-open");
    });
  });
}
